// Voisines géographiques réelles (calculées via geo.api.gouv.fr, centres INSEE).
// Repli alphabétique côté page si une commune est absente.
export const NEIGHBOURS = {
  "Aiglun": [
    "Sigale",
    "Sallagriffon",
    "La Roque-en-Provence",
    "Gréolières",
    "Les Mujouls",
    "Cuébris"
  ],
  "Amirat": [
    "Gars",
    "Collongues",
    "Les Mujouls",
    "Briançonnet",
    "Le Mas",
    "Sallagriffon"
  ],
  "Andon": [
    "Caille",
    "Escragnolles",
    "Le Mas",
    "Caussols",
    "Cipières",
    "Saint-Vallier-de-Thiey"
  ],
  "Antibes": [
    "Vallauris",
    "Biot",
    "Villeneuve-Loubet",
    "Valbonne",
    "Mougins",
    "Cannes"
  ],
  "Ascros": [
    "Touët-sur-Var",
    "Saint-Antonin",
    "Cuébris",
    "Roquestéron",
    "Pierrefeu",
    "Sigale"
  ],
  "Aspremont": [
    "Castagniers",
    "Colomars",
    "Tourrette-Levens",
    "Falicon",
    "Saint-Blaise",
    "Châteauneuf-Villevieille"
  ],
  "Auribeau-sur-Siagne": [
    "Pégomas",
    "Peymeinade",
    "La Roquette-sur-Siagne",
    "Mouans-Sartoux",
    "Le Tignet",
    "Grasse"
  ],
  "Auvare": [
    "Puget-Rostang",
    "La Croix-sur-Roudoule",
    "Rigaud",
    "Puget-Théniers",
    "Saint-Léger",
    "Pierlas"
  ],
  "Bairols": [
    "Massoins",
    "Villars-sur-Var",
    "Clans",
    "Ilonse",
    "Tournefort",
    "Marie"
  ],
  "Le Bar-sur-Loup": [
    "Gourdon",
    "Le Rouret",
    "Châteauneuf-Grasse",
    "Grasse",
    "Opio",
    "Tourrettes-sur-Loup"
  ],
  "Beaulieu-sur-Mer": [
    "Villefranche-sur-Mer",
    "Saint-Jean-Cap-Ferrat",
    "Èze",
    "La Trinité",
    "Saint-André-de-la-Roche",
    "Drap"
  ],
  "Beausoleil": [
    "La Turbie",
    "Cap-d'Ail",
    "Roquebrune-Cap-Martin",
    "Gorbio",
    "Peillon",
    "Èze"
  ],
  "Belvédère": [
    "Saint-Martin-Vésubie",
    "Roquebillière",
    "La Bollène-Vésubie",
    "Lantosque",
    "Venanson",
    "Moulinet"
  ],
  "Bendejun": [
    "Châteauneuf-Villevieille",
    "Berre-les-Alpes",
    "Contes",
    "Levens",
    "Coaraze",
    "Tourrette-Levens"
  ],
  "Berre-les-Alpes": [
    "Contes",
    "L'Escarène",
    "Bendejun",
    "Touët-de-l'Escarène",
    "Coaraze",
    "Châteauneuf-Villevieille"
  ],
  "Beuil": [
    "Péone",
    "Roubion",
    "Roure",
    "Guillaumes",
    "Pierlas",
    "Châteauneuf-d'Entraunes"
  ],
  "Bézaudun-les-Alpes": [
    "Bouyon",
    "Coursegoules",
    "Les Ferres",
    "Conségudes",
    "Le Broc",
    "Saint-Jeannet"
  ],
  "Biot": [
    "Villeneuve-Loubet",
    "Valbonne",
    "Antibes",
    "Roquefort-les-Pins",
    "Vallauris",
    "Opio"
  ],
  "Blausasc": [
    "Peillon",
    "Contes",
    "L'Escarène",
    "Drap",
    "Peille",
    "Cantaron"
  ],
  "La Bollène-Vésubie": [
    "Lantosque",
    "Moulinet",
    "Belvédère",
    "Roquebillière",
    "Lucéram",
    "Breil-sur-Roya"
  ],
  "Bonson": [
    "Revest-les-Roches",
    "Gilette",
    "La Roquette-sur-Var",
    "Tourette-du-Château",
    "Levens",
    "Saint-Martin-du-Var"
  ],
  "Bouyon": [
    "Les Ferres",
    "Le Broc",
    "Gilette",
    "Bézaudun-les-Alpes",
    "Bonson",
    "Tourette-du-Château"
  ],
  "Breil-sur-Roya": [
    "Sospel",
    "Saorge",
    "Moulinet",
    "Fontan",
    "Castillon",
    "La Bollène-Vésubie"
  ],
  "Briançonnet": [
    "Saint-Auban",
    "Gars",
    "Amirat",
    "Valderoure",
    "Le Mas",
    "Les Mujouls"
  ],
  "La Brigue": [
    "Tende",
    "Fontan",
    "Saorge",
    "Breil-sur-Roya",
    "Belvédère",
    "La Bollène-Vésubie"
  ],
  "Le Broc": [
    "Saint-Martin-du-Var",
    "Gilette",
    "Bouyon",
    "Carros",
    "La Roquette-sur-Var",
    "Gattières"
  ],
  "Cabris": [
    "Spéracèdes",
    "Peymeinade",
    "Le Tignet",
    "Grasse",
    "Saint-Vallier-de-Thiey",
    "Saint-Cézaire-sur-Siagne"
  ],
  "Cagnes-sur-Mer": [
    "Saint-Laurent-du-Var",
    "Saint-Paul-de-Vence",
    "La Colle-sur-Loup",
    "Villeneuve-Loubet",
    "La Gaude",
    "Biot"
  ],
  "Caille": [
    "Valderoure",
    "Séranon",
    "Escragnolles",
    "Andon",
    "Saint-Auban",
    "Briançonnet"
  ],
  "Cannes": [
    "Le Cannet",
    "Vallauris",
    "Mougins",
    "La Roquette-sur-Siagne",
    "Mandelieu-la-Napoule",
    "Antibes"
  ],
  "Le Cannet": [
    "Mougins",
    "Cannes",
    "La Roquette-sur-Siagne",
    "Vallauris",
    "Mouans-Sartoux",
    "Valbonne"
  ],
  "Cantaron": [
    "Drap",
    "Saint-André-de-la-Roche",
    "La Trinité",
    "Tourrette-Levens",
    "Châteauneuf-Villevieille",
    "Peillon"
  ],
  "Cap-d'Ail": [
    "La Turbie",
    "Beausoleil",
    "Èze",
    "La Trinité",
    "Beaulieu-sur-Mer",
    "Peillon"
  ],
  "Carros": [
    "Gattières",
    "Le Broc",
    "Saint-Jeannet",
    "Saint-Martin-du-Var",
    "Castagniers",
    "Colomars"
  ],
  "Castagniers": [
    "Aspremont",
    "Saint-Blaise",
    "Tourrette-Levens",
    "Colomars",
    "Saint-Martin-du-Var",
    "Carros"
  ],
  "Castellar": [
    "Menton",
    "Castillon",
    "Sainte-Agnès",
    "Gorbio",
    "Roquebrune-Cap-Martin",
    "Peille"
  ],
  "Castillon": [
    "Castellar",
    "Sainte-Agnès",
    "Menton",
    "Peille",
    "Sospel",
    "Gorbio"
  ],
  "Caussols": [
    "Cipières",
    "Gourdon",
    "Saint-Vallier-de-Thiey",
    "Le Bar-sur-Loup",
    "Gréolières",
    "Andon"
  ],
  "Châteauneuf-Grasse": [
    "Opio",
    "Le Rouret",
    "Grasse",
    "Le Bar-sur-Loup",
    "Mouans-Sartoux",
    "Valbonne"
  ],
  "Châteauneuf-Villevieille": [
    "Tourrette-Levens",
    "Contes",
    "Bendejun",
    "Cantaron",
    "Berre-les-Alpes",
    "Aspremont"
  ],
  "Châteauneuf-d'Entraunes": [
    "Villeneuve-d'Entraunes",
    "Guillaumes",
    "Péone",
    "Saint-Martin-d'Entraunes",
    "Sauze",
    "Entraunes"
  ],
  "Cipières": [
    "Caussols",
    "Gréolières",
    "Gourdon",
    "Courmes",
    "Andon",
    "Le Bar-sur-Loup"
  ],
  "Clans": [
    "Marie",
    "La Tour",
    "Bairols",
    "Venanson",
    "Massoins",
    "Tournefort"
  ],
  "Coaraze": [
    "Duranus",
    "Bendejun",
    "Berre-les-Alpes",
    "Lucéram",
    "Levens",
    "Contes"
  ],
  "La Colle-sur-Loup": [
    "Saint-Paul-de-Vence",
    "Roquefort-les-Pins",
    "Villeneuve-Loubet",
    "Cagnes-sur-Mer",
    "Vence",
    "Tourrettes-sur-Loup"
  ],
  "Collongues": [
    "Les Mujouls",
    "Sallagriffon",
    "Amirat",
    "Gars",
    "Le Mas",
    "La Penne"
  ],
  "Colomars": [
    "Aspremont",
    "Falicon",
    "Castagniers",
    "Gattières",
    "Carros",
    "Saint-André-de-la-Roche"
  ],
  "Conségudes": [
    "Roquestéron",
    "La Roque-en-Provence",
    "Les Ferres",
    "Coursegoules",
    "Bézaudun-les-Alpes",
    "Pierrefeu"
  ],
  "Contes": [
    "Berre-les-Alpes",
    "Châteauneuf-Villevieille",
    "Blausasc",
    "L'Escarène",
    "Bendejun",
    "Cantaron"
  ],
  "Courmes": [
    "Tourrettes-sur-Loup",
    "Coursegoules",
    "Gourdon",
    "Vence",
    "Le Bar-sur-Loup",
    "Cipières"
  ],
  "Coursegoules": [
    "Bézaudun-les-Alpes",
    "Courmes",
    "Conségudes",
    "Les Ferres",
    "La Roque-en-Provence",
    "Vence"
  ],
  "La Croix-sur-Roudoule": [
    "Auvare",
    "Saint-Léger",
    "Puget-Rostang",
    "Puget-Théniers",
    "Daluis",
    "Rigaud"
  ],
  "Cuébris": [
    "Saint-Antonin",
    "Sigale",
    "Roquestéron",
    "Ascros",
    "La Roque-en-Provence",
    "La Penne"
  ],
  "Daluis": [
    "Saint-Léger",
    "Sauze",
    "La Croix-sur-Roudoule",
    "Guillaumes",
    "Auvare",
    "Villeneuve-d'Entraunes"
  ],
  "Drap": [
    "La Trinité",
    "Cantaron",
    "Peillon",
    "Èze",
    "Blausasc",
    "Saint-André-de-la-Roche"
  ],
  "Duranus": [
    "Coaraze",
    "Utelle",
    "Lucéram",
    "Levens",
    "Bendejun",
    "Berre-les-Alpes"
  ],
  "Entraunes": [
    "Saint-Martin-d'Entraunes",
    "Saint-Dalmas-le-Selvage",
    "Châteauneuf-d'Entraunes",
    "Villeneuve-d'Entraunes",
    "Saint-Étienne-de-Tinée",
    "Sauze"
  ],
  "L'Escarène": [
    "Touët-de-l'Escarène",
    "Berre-les-Alpes",
    "Contes",
    "Blausasc",
    "Peille",
    "Peillon"
  ],
  "Escragnolles": [
    "Caille",
    "Saint-Vallier-de-Thiey",
    "Andon",
    "Saint-Cézaire-sur-Siagne",
    "Séranon",
    "Valderoure"
  ],
  "Falicon": [
    "Saint-André-de-la-Roche",
    "Aspremont",
    "Colomars",
    "Tourrette-Levens",
    "Cantaron",
    "Castagniers"
  ],
  "Les Ferres": [
    "Bouyon",
    "Bézaudun-les-Alpes",
    "Conségudes",
    "Toudon",
    "Gilette",
    "Tourette-du-Château"
  ],
  "Fontan": [
    "Saorge",
    "Tende",
    "Breil-sur-Roya",
    "La Brigue",
    "Moulinet",
    "La Bollène-Vésubie"
  ],
  "Gars": [
    "Les Mujouls",
    "Le Mas",
    "Amirat",
    "Collongues",
    "Briançonnet",
    "Saint-Auban"
  ],
  "Gattières": [
    "Saint-Jeannet",
    "Carros",
    "Colomars",
    "Le Broc",
    "Castagniers",
    "La Gaude"
  ],
  "La Gaude": [
    "Saint-Laurent-du-Var",
    "Saint-Paul-de-Vence",
    "Saint-Jeannet",
    "Cagnes-sur-Mer",
    "Vence",
    "Gattières"
  ],
  "Gilette": [
    "Bonson",
    "Le Broc",
    "Bouyon",
    "La Roquette-sur-Var",
    "Revest-les-Roches",
    "Saint-Martin-du-Var"
  ],
  "Gorbio": [
    "Sainte-Agnès",
    "Roquebrune-Cap-Martin",
    "Peille",
    "Menton",
    "Beausoleil",
    "Castillon"
  ],
  "Gourdon": [
    "Le Bar-sur-Loup",
    "Caussols",
    "Courmes",
    "Cipières",
    "Tourrettes-sur-Loup",
    "Le Rouret"
  ],
  "Grasse": [
    "Châteauneuf-Grasse",
    "Cabris",
    "Mouans-Sartoux",
    "Le Bar-sur-Loup",
    "Peymeinade",
    "Auribeau-sur-Siagne"
  ],
  "Gréolières": [
    "Cipières",
    "Aiglun",
    "Le Mas",
    "La Roque-en-Provence",
    "Caussols",
    "Sigale"
  ],
  "Guillaumes": [
    "Sauze",
    "Péone",
    "Châteauneuf-d'Entraunes",
    "Villeneuve-d'Entraunes",
    "Daluis",
    "Beuil"
  ],
  "Ilonse": [
    "Lieuche",
    "Bairols",
    "Pierlas",
    "Marie",
    "Thiéry",
    "Clans"
  ],
  "Isola": [
    "Roure",
    "Saint-Sauveur-sur-Tinée",
    "Roubion",
    "Rimplas",
    "Beuil",
    "Valdeblore"
  ],
  "Lantosque": [
    "La Bollène-Vésubie",
    "Roquebillière",
    "Utelle",
    "Moulinet",
    "Venanson",
    "Lucéram"
  ],
  "Levens": [
    "La Roquette-sur-Var",
    "Saint-Blaise",
    "Bendejun",
    "Saint-Martin-du-Var",
    "Bonson",
    "Coaraze"
  ],
  "Lieuche": [
    "Thiéry",
    "Pierlas",
    "Rigaud",
    "Ilonse",
    "Villars-sur-Var",
    "Touët-sur-Var"
  ],
  "Lucéram": [
    "Coaraze",
    "Duranus",
    "Touët-de-l'Escarène",
    "Berre-les-Alpes",
    "Moulinet",
    "L'Escarène"
  ],
  "Malaussène": [
    "Tournefort",
    "Tourette-du-Château",
    "Toudon",
    "Revest-les-Roches",
    "Massoins",
    "Pierrefeu"
  ],
  "Mandelieu-la-Napoule": [
    "Théoule-sur-Mer",
    "Pégomas",
    "La Roquette-sur-Siagne",
    "Cannes",
    "Le Cannet",
    "Auribeau-sur-Siagne"
  ],
  "Marie": [
    "Clans",
    "Venanson",
    "Ilonse",
    "Bairols",
    "Rimplas",
    "La Tour"
  ],
  "Le Mas": [
    "Les Mujouls",
    "Gars",
    "Collongues",
    "Sallagriffon",
    "Aiglun",
    "Gréolières"
  ],
  "Massoins": [
    "Tournefort",
    "Bairols",
    "Villars-sur-Var",
    "Malaussène",
    "La Tour",
    "Clans"
  ],
  "Menton": [
    "Castellar",
    "Sainte-Agnès",
    "Gorbio",
    "Roquebrune-Cap-Martin",
    "Castillon",
    "Peille"
  ],
  "Mouans-Sartoux": [
    "La Roquette-sur-Siagne",
    "Mougins",
    "Auribeau-sur-Siagne",
    "Grasse",
    "Châteauneuf-Grasse",
    "Valbonne"
  ],
  "Mougins": [
    "Le Cannet",
    "Mouans-Sartoux",
    "Valbonne",
    "La Roquette-sur-Siagne",
    "Vallauris",
    "Cannes"
  ],
  "Moulinet": [
    "La Bollène-Vésubie",
    "Breil-sur-Roya",
    "Lucéram",
    "Sospel",
    "Lantosque",
    "Saorge"
  ],
  "Les Mujouls": [
    "Collongues",
    "Gars",
    "Le Mas",
    "Sallagriffon",
    "Amirat",
    "Aiglun"
  ],
  "Nice": [
    "Saint-André-de-la-Roche",
    "Falicon",
    "Villefranche-sur-Mer",
    "Saint-Laurent-du-Var",
    "Beaulieu-sur-Mer",
    "Colomars"
  ],
  "Opio": [
    "Châteauneuf-Grasse",
    "Le Rouret",
    "Valbonne",
    "Roquefort-les-Pins",
    "Mouans-Sartoux",
    "Le Bar-sur-Loup"
  ],
  "Peille": [
    "Gorbio",
    "Sainte-Agnès",
    "Blausasc",
    "L'Escarène",
    "Peillon",
    "Castillon"
  ],
  "Peillon": [
    "Blausasc",
    "Drap",
    "La Turbie",
    "La Trinité",
    "Cantaron",
    "Èze"
  ],
  "La Penne": [
    "Saint-Antonin",
    "Puget-Théniers",
    "Sallagriffon",
    "Sigale",
    "Cuébris",
    "Touët-sur-Var"
  ],
  "Peymeinade": [
    "Le Tignet",
    "Spéracèdes",
    "Auribeau-sur-Siagne",
    "Cabris",
    "Grasse",
    "Pégomas"
  ],
  "Pierlas": [
    "Lieuche",
    "Rigaud",
    "Ilonse",
    "Thiéry",
    "Puget-Rostang",
    "Roubion"
  ],
  "Pierrefeu": [
    "Toudon",
    "Roquestéron",
    "Tourette-du-Château",
    "Les Ferres",
    "Ascros",
    "Malaussène"
  ],
  "Puget-Rostang": [
    "Auvare",
    "Rigaud",
    "La Croix-sur-Roudoule",
    "Puget-Théniers",
    "Pierlas",
    "Lieuche"
  ],
  "Puget-Théniers": [
    "La Penne",
    "Auvare",
    "La Croix-sur-Roudoule",
    "Puget-Rostang",
    "Collongues",
    "Saint-Antonin"
  ],
  "Pégomas": [
    "La Roquette-sur-Siagne",
    "Auribeau-sur-Siagne",
    "Mouans-Sartoux",
    "Peymeinade",
    "Mandelieu-la-Napoule",
    "Le Cannet"
  ],
  "Péone": [
    "Beuil",
    "Guillaumes",
    "Châteauneuf-d'Entraunes",
    "Roubion",
    "Roure",
    "Sauze"
  ],
  "Revest-les-Roches": [
    "Bonson",
    "Tourette-du-Château",
    "Malaussène",
    "Gilette",
    "Toudon",
    "La Roquette-sur-Var"
  ],
  "Rigaud": [
    "Puget-Rostang",
    "Lieuche",
    "Auvare",
    "Thiéry",
    "Pierlas",
    "Touët-sur-Var"
  ],
  "Rimplas": [
    "Saint-Sauveur-sur-Tinée",
    "Valdeblore",
    "Roure",
    "Marie",
    "Ilonse",
    "Roubion"
  ],
  "La Roque-en-Provence": [
    "Roquestéron",
    "Sigale",
    "Conségudes",
    "Cuébris",
    "Aiglun",
    "Saint-Antonin"
  ],
  "Roquebillière": [
    "Venanson",
    "Lantosque",
    "Belvédère",
    "Saint-Martin-Vésubie",
    "La Bollène-Vésubie",
    "Clans"
  ],
  "Roquebrune-Cap-Martin": [
    "Gorbio",
    "Beausoleil",
    "Sainte-Agnès",
    "Menton",
    "La Turbie",
    "Peille"
  ],
  "Roquefort-les-Pins": [
    "La Colle-sur-Loup",
    "Le Rouret",
    "Opio",
    "Villeneuve-Loubet",
    "Tourrettes-sur-Loup",
    "Biot"
  ],
  "Roquestéron": [
    "Cuébris",
    "La Roque-en-Provence",
    "Conségudes",
    "Pierrefeu",
    "Sigale",
    "Ascros"
  ],
  "La Roquette-sur-Siagne": [
    "Pégomas",
    "Auribeau-sur-Siagne",
    "Mouans-Sartoux",
    "Le Cannet",
    "Mougins",
    "Mandelieu-la-Napoule"
  ],
  "La Roquette-sur-Var": [
    "Saint-Martin-du-Var",
    "Saint-Blaise",
    "Levens",
    "Bonson",
    "Gilette",
    "Le Broc"
  ],
  "Roubion": [
    "Roure",
    "Beuil",
    "Saint-Sauveur-sur-Tinée",
    "Péone",
    "Pierlas",
    "Rimplas"
  ],
  "Roure": [
    "Roubion",
    "Saint-Sauveur-sur-Tinée",
    "Rimplas",
    "Beuil",
    "Isola",
    "Pierlas"
  ],
  "Le Rouret": [
    "Opio",
    "Châteauneuf-Grasse",
    "Le Bar-sur-Loup",
    "Roquefort-les-Pins",
    "Tourrettes-sur-Loup",
    "Valbonne"
  ],
  "Saint-André-de-la-Roche": [
    "Falicon",
    "Cantaron",
    "La Trinité",
    "Drap",
    "Tourrette-Levens",
    "Aspremont"
  ],
  "Saint-Antonin": [
    "Cuébris",
    "La Penne",
    "Ascros",
    "Sigale",
    "Touët-sur-Var",
    "Roquestéron"
  ],
  "Saint-Auban": [
    "Briançonnet",
    "Valderoure",
    "Caille",
    "Gars",
    "Séranon",
    "Andon"
  ],
  "Saint-Blaise": [
    "Saint-Martin-du-Var",
    "Castagniers",
    "La Roquette-sur-Var",
    "Levens",
    "Aspremont",
    "Tourrette-Levens"
  ],
  "Saint-Cézaire-sur-Siagne": [
    "Spéracèdes",
    "Le Tignet",
    "Saint-Vallier-de-Thiey",
    "Cabris",
    "Peymeinade",
    "Escragnolles"
  ],
  "Saint-Dalmas-le-Selvage": [
    "Saint-Étienne-de-Tinée",
    "Entraunes",
    "Châteauneuf-d'Entraunes",
    "Saint-Martin-d'Entraunes",
    "Péone",
    "Villeneuve-d'Entraunes"
  ],
  "Saint-Étienne-de-Tinée": [
    "Saint-Dalmas-le-Selvage",
    "Châteauneuf-d'Entraunes",
    "Entraunes",
    "Péone",
    "Isola",
    "Beuil"
  ],
  "Sainte-Agnès": [
    "Gorbio",
    "Menton",
    "Castillon",
    "Castellar",
    "Peille",
    "Roquebrune-Cap-Martin"
  ],
  "Saint-Jean-Cap-Ferrat": [
    "Beaulieu-sur-Mer",
    "Villefranche-sur-Mer",
    "Èze",
    "La Trinité",
    "Cap-d'Ail",
    "Nice"
  ],
  "Saint-Jeannet": [
    "Gattières",
    "Carros",
    "Vence",
    "La Gaude",
    "Colomars",
    "Le Broc"
  ],
  "Saint-Laurent-du-Var": [
    "Cagnes-sur-Mer",
    "La Gaude",
    "Saint-Paul-de-Vence",
    "Nice",
    "La Colle-sur-Loup",
    "Villeneuve-Loubet"
  ],
  "Saint-Léger": [
    "La Croix-sur-Roudoule",
    "Daluis",
    "Auvare",
    "Puget-Théniers",
    "Puget-Rostang",
    "Sauze"
  ],
  "Saint-Martin-d'Entraunes": [
    "Villeneuve-d'Entraunes",
    "Châteauneuf-d'Entraunes",
    "Sauze",
    "Entraunes",
    "Guillaumes",
    "Daluis"
  ],
  "Saint-Martin-du-Var": [
    "La Roquette-sur-Var",
    "Saint-Blaise",
    "Le Broc",
    "Castagniers",
    "Carros",
    "Gilette"
  ],
  "Saint-Martin-Vésubie": [
    "Belvédère",
    "Roquebillière",
    "Venanson",
    "Valdeblore",
    "La Bollène-Vésubie",
    "Lantosque"
  ],
  "Saint-Paul-de-Vence": [
    "La Colle-sur-Loup",
    "Cagnes-sur-Mer",
    "La Gaude",
    "Saint-Laurent-du-Var",
    "Vence",
    "Villeneuve-Loubet"
  ],
  "Saint-Sauveur-sur-Tinée": [
    "Rimplas",
    "Roure",
    "Valdeblore",
    "Roubion",
    "Isola",
    "Ilonse"
  ],
  "Saint-Vallier-de-Thiey": [
    "Cabris",
    "Spéracèdes",
    "Saint-Cézaire-sur-Siagne",
    "Caussols",
    "Escragnolles",
    "Peymeinade"
  ],
  "Sallagriffon": [
    "Aiglun",
    "Les Mujouls",
    "Collongues",
    "Sigale",
    "La Penne",
    "Saint-Antonin"
  ],
  "Saorge": [
    "Fontan",
    "Breil-sur-Roya",
    "Moulinet",
    "Tende",
    "La Bollène-Vésubie",
    "La Brigue"
  ],
  "Sauze": [
    "Daluis",
    "Villeneuve-d'Entraunes",
    "Guillaumes",
    "Saint-Martin-d'Entraunes",
    "Châteauneuf-d'Entraunes",
    "Saint-Léger"
  ],
  "Sigale": [
    "Cuébris",
    "Aiglun",
    "La Roque-en-Provence",
    "Saint-Antonin",
    "Sallagriffon",
    "Roquestéron"
  ],
  "Sospel": [
    "Castillon",
    "Touët-de-l'Escarène",
    "Breil-sur-Roya",
    "Moulinet",
    "Lucéram",
    "Castellar"
  ],
  "Spéracèdes": [
    "Cabris",
    "Le Tignet",
    "Peymeinade",
    "Saint-Cézaire-sur-Siagne",
    "Saint-Vallier-de-Thiey",
    "Auribeau-sur-Siagne"
  ],
  "Séranon": [
    "Valderoure",
    "Caille",
    "Saint-Auban",
    "Escragnolles",
    "Andon",
    "Briançonnet"
  ],
  "Tende": [
    "La Brigue",
    "Fontan",
    "Saorge",
    "Belvédère",
    "La Bollène-Vésubie",
    "Breil-sur-Roya"
  ],
  "Thiéry": [
    "Lieuche",
    "Villars-sur-Var",
    "Touët-sur-Var",
    "Rigaud",
    "Bairols",
    "Pierlas"
  ],
  "Théoule-sur-Mer": [
    "Mandelieu-la-Napoule",
    "Cannes",
    "La Roquette-sur-Siagne",
    "Pégomas",
    "Le Cannet",
    "Mougins"
  ],
  "Le Tignet": [
    "Peymeinade",
    "Spéracèdes",
    "Cabris",
    "Auribeau-sur-Siagne",
    "Saint-Cézaire-sur-Siagne",
    "Pégomas"
  ],
  "Toudon": [
    "Tourette-du-Château",
    "Pierrefeu",
    "Malaussène",
    "Revest-les-Roches",
    "Les Ferres",
    "Bonson"
  ],
  "La Tour": [
    "Tournefort",
    "Clans",
    "Utelle",
    "Massoins",
    "Bairols",
    "Malaussène"
  ],
  "Tourette-du-Château": [
    "Toudon",
    "Revest-les-Roches",
    "Malaussène",
    "Bonson",
    "Gilette",
    "Pierrefeu"
  ],
  "Tournefort": [
    "Massoins",
    "Malaussène",
    "La Tour",
    "Bairols",
    "Revest-les-Roches",
    "Villars-sur-Var"
  ],
  "Tourrette-Levens": [
    "Châteauneuf-Villevieille",
    "Aspremont",
    "Castagniers",
    "Cantaron",
    "Falicon",
    "Saint-Blaise"
  ],
  "Tourrettes-sur-Loup": [
    "Courmes",
    "Le Rouret",
    "Roquefort-les-Pins",
    "Vence",
    "Le Bar-sur-Loup",
    "Gourdon"
  ],
  "Touët-de-l'Escarène": [
    "L'Escarène",
    "Berre-les-Alpes",
    "Peille",
    "Lucéram",
    "Contes",
    "Coaraze"
  ],
  "Touët-sur-Var": [
    "Ascros",
    "Thiéry",
    "Saint-Antonin",
    "Villars-sur-Var",
    "Cuébris",
    "Rigaud"
  ],
  "La Trinité": [
    "Èze",
    "Drap",
    "Cantaron",
    "Beaulieu-sur-Mer",
    "Villefranche-sur-Mer",
    "Peillon"
  ],
  "La Turbie": [
    "Beausoleil",
    "Cap-d'Ail",
    "Èze",
    "Peillon",
    "La Trinité",
    "Drap"
  ],
  "Utelle": [
    "La Tour",
    "Duranus",
    "Lantosque",
    "Tournefort",
    "Clans",
    "Revest-les-Roches"
  ],
  "Valbonne": [
    "Opio",
    "Mougins",
    "Biot",
    "Mouans-Sartoux",
    "Roquefort-les-Pins",
    "Châteauneuf-Grasse"
  ],
  "Valdeblore": [
    "Rimplas",
    "Saint-Sauveur-sur-Tinée",
    "Venanson",
    "Saint-Martin-Vésubie",
    "Marie",
    "Roure"
  ],
  "Valderoure": [
    "Séranon",
    "Saint-Auban",
    "Caille",
    "Briançonnet",
    "Andon",
    "Escragnolles"
  ],
  "Vallauris": [
    "Antibes",
    "Mougins",
    "Le Cannet",
    "Cannes",
    "Biot",
    "Valbonne"
  ],
  "Venanson": [
    "Roquebillière",
    "Marie",
    "Clans",
    "Saint-Martin-Vésubie",
    "Valdeblore",
    "Lantosque"
  ],
  "Vence": [
    "Saint-Jeannet",
    "Saint-Paul-de-Vence",
    "La Gaude",
    "Tourrettes-sur-Loup",
    "La Colle-sur-Loup",
    "Gattières"
  ],
  "Villars-sur-Var": [
    "Thiéry",
    "Massoins",
    "Bairols",
    "Touët-sur-Var",
    "Lieuche",
    "Ascros"
  ],
  "Villefranche-sur-Mer": [
    "Beaulieu-sur-Mer",
    "Saint-Jean-Cap-Ferrat",
    "Èze",
    "La Trinité",
    "Saint-André-de-la-Roche",
    "Drap"
  ],
  "Villeneuve-d'Entraunes": [
    "Saint-Martin-d'Entraunes",
    "Sauze",
    "Châteauneuf-d'Entraunes",
    "Guillaumes",
    "Daluis",
    "Entraunes"
  ],
  "Villeneuve-Loubet": [
    "Biot",
    "Roquefort-les-Pins",
    "La Colle-sur-Loup",
    "Cagnes-sur-Mer",
    "Saint-Paul-de-Vence",
    "Valbonne"
  ],
  "Èze": [
    "La Trinité",
    "Beaulieu-sur-Mer",
    "Drap",
    "Villefranche-sur-Mer",
    "Cap-d'Ail",
    "La Turbie"
  ]
};
